import { render, staticRenderFns } from "./ContactFormModal.vue?vue&type=template&id=b8a04d5c&scoped=true&"
import script from "./ContactFormModal.vue?vue&type=script&lang=js&"
export * from "./ContactFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ContactFormModal.vue?vue&type=style&index=0&id=b8a04d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a04d5c",
  null
  
)

export default component.exports